module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/pictogram-house-on-a-hill-367213c4ee1430f6fc1b904ee19492c2.svg";